import { render, staticRenderFns } from "./PublicTableItem.vue?vue&type=template&id=80821d58&"
import script from "./PublicTableItem.vue?vue&type=script&lang=ts&"
export * from "./PublicTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports